import ColorPickerOverlay from './ColorPickerOverlay';

export default ColorPickerOverlay;